import { defineSagaForService } from '@repo/core'
import { otpResend } from '@repo/user-services'
import { otpResendActions } from '../../slices'

export const otpMutationsServiceConfig = defineSagaForService({
  [otpResendActions.postRequest.type]: {
    apiClientDomain: 'user',
    service: otpResend,
    actionTypeResponse: otpResendActions.postResponse.type,
    actionTypeRequest: otpResendActions.postRequest.type,
  },
})
